var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocation20Px(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8621 8.95618C16.8621 14.335 11.353 17.6488 10.2081 18.28C10.1446 18.3149 10.0734 18.3333 10.001 18.3333C9.92852 18.3333 9.85727 18.3149 9.79385 18.28C8.6481 17.6488 3.14062 14.335 3.14062 8.95618C3.14062 4.66821 5.71341 1.66663 10.0014 1.66663C14.2894 1.66663 16.8621 4.66821 16.8621 8.95618Z",
    stroke: "#033B5A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.57031 8.52743C6.57031 9.43722 6.93173 10.3098 7.57505 10.9531C8.21837 11.5964 9.0909 11.9578 10.0007 11.9578C10.9105 11.9578 11.783 11.5964 12.4263 10.9531C13.0697 10.3098 13.4311 9.43722 13.4311 8.52743C13.4311 7.61763 13.0697 6.7451 12.4263 6.10178C11.783 5.45846 10.9105 5.09705 10.0007 5.09705C9.0909 5.09705 8.21837 5.45846 7.57505 6.10178C6.93173 6.7451 6.57031 7.61763 6.57031 8.52743V8.52743Z",
    stroke: "#033B5A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation20Px);
export default __webpack_public_path__ + "static/media/location-20px.5b1a25537eb66bafa9576514a3b02bf6.svg";
export { ForwardRef as ReactComponent };